import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classes from '../../../pipeline.module.scss';
import Table from '../../../../../../_common/Tables/Table';
import { formattedCount } from '../../../pipelineHelpers';
import { TOTAL_LABEL } from './pivotHelpers';

const cellValue = (value) => (value ? formattedCount(value) : '-');

const PivotTable = ({
  firstColTitle = '', titles = [], columns, data, showTotalCol = true, className = '',
}) => {
  const header = useMemo(() => {
    const valueCell = (path, isTotalColumn = false) => (row) => (
      <span className={row.isTotal || isTotalColumn ? classes.pivot_total_cell : classes.pivot_cell}>
        {cellValue(row[path])}
      </span>
    );

    if (titles.length) {
      return titles.map((title) => ({
        name: title,
        path: title,
        render: (row) => (
          <span className={row.isTotal ? classes.pivot_total_cell : classes.pivot_row_label}>
            {row[title]}
          </span>
        ),
      }));
    }

    const tableHeader = [];

    if (firstColTitle) {
      tableHeader.push({
        name: firstColTitle,
        path: 'label',
        render: (row) => (
          <span className={row.isTotal ? classes.pivot_total_cell : classes.pivot_row_label}>
            {row.label}
          </span>
        ),
      });
    }

    columns.forEach((column) => tableHeader.push({
      name: column,
      path: column,
      render: valueCell(column),
    }));

    if (showTotalCol) {
      tableHeader.push({
        name: TOTAL_LABEL,
        path: 'total',
        render: valueCell('total', true),
      });
    }

    return tableHeader;
  }, [firstColTitle, columns, showTotalCol]);

  const tableData = titles.length
    ? _.map(data[0], (val, key) => {
      const [firstTitle, secondTitle] = titles;

      return {
        [firstTitle]: key === 'total' ? 'Total Result' : key,
        [secondTitle]: val,
        isTotal: key === 'total',
      };
    })

    : data;

  return (
    <div className={`${classes.pipeline_table} ${className}`}>
      <Table
        header={header}
        data={tableData}
      />
    </div>
  );
};

PivotTable.propTypes = {
  firstColTitle: PropTypes.string,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  showTotalCol: PropTypes.bool,
  className: PropTypes.string,
};

export default PivotTable;
